import React, { useState } from "react";

const PrepareExport = () => {
    const [form, setForm] = useState({
        boxNumber: "",
        destination: "",
        weight: "",
        status: "En attente",
        exportedBy: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Nouvelle exportation préparée :", form);
        setForm({ boxNumber: "", destination: "", weight: "", status: "En attente", exportedBy: "" });
    };

    return (
        <div className="max-w-4xl mx-auto p-4">
            <h1 className="text-2xl font-bold mb-4">Préparer une exportation</h1>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label className="block mb-2 font-semibold">Numéro de boîte :</label>
                    <input
                        type="text"
                        name="boxNumber"
                        value={form.boxNumber}
                        onChange={handleChange}
                        className="border border-gray-300 rounded p-2 w-full"
                        required
                    />
                </div>
                <div>
                    <label className="block mb-2 font-semibold">Destination :</label>
                    <input
                        type="text"
                        name="destination"
                        value={form.destination}
                        onChange={handleChange}
                        className="border border-gray-300 rounded p-2 w-full"
                        required
                    />
                </div>
                <div>
                    <label className="block mb-2 font-semibold">Poids :</label>
                    <input
                        type="text"
                        name="weight"
                        value={form.weight}
                        onChange={handleChange}
                        className="border border-gray-300 rounded p-2 w-full"
                        required
                    />
                </div>
                <div>
                    <label className="block mb-2 font-semibold">Exporté par :</label>
                    <input
                        type="text"
                        name="exportedBy"
                        value={form.exportedBy}
                        onChange={handleChange}
                        className="border border-gray-300 rounded p-2 w-full"
                        required
                    />
                </div>
                <button
                    type="submit"
                    className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-700"
                >
                    Préparer
                </button>
            </form>
        </div>
    );
};

export default PrepareExport;
